<template>
  <button type="button" title="Удалить" class="delete-btn">
    <SvgIcon icon="trash" />
  </button>
</template>

<script lang="ts" src="./DeleteIconBtn.ts"></script>

<style scoped lang="scss" src="./DeleteIconBtn.scss"></style>
